<template>
    <div v-if="isLoading" class="loading-container">
        <img :src="require('@/assets/10.png')" alt="Logo" class="loading-logo" />
    </div>
    <div v-else>
        <div class="slide">
            <div class="bg-img">
                <div class="slide-content">
                    <div><h2 class="slide-header">{{ $t('message.equipments') }}</h2></div>
                <div>
                    <h5 class="slide-h5">{{ $t('message.home') }}</h5>
                    <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider"></b-icon>
                    <h5 class="slide-h5">{{ $t('message.equipments') }}</h5>
                </div>
            </div>
            </div>
        </div>
        <div class="container custom-container-orders mt-5" :class="{ 'equip-page-rtl': isRTL }">
            <b-row class="equip-action-row align-items-center">
                <b-col cols="12" md="6" class="equip-filter-col d-flex align-items-center">
                    <h3 class="filter-text">{{ $t('message.filter') }}</h3>
                    <b-form-input class="filter-input" id="filter-input" v-model="filter"
                    :placeholder="$t('message.equipmentName')"></b-form-input>
                </b-col>
                <b-col cols="12" md="6" class="equip-btn-col text-right">
                    <b-button variant="warning" class="new-order equip-add-btn" @click="openAddEquipmentModal">
                    <b-icon icon="plus-circle" class="mr-2"></b-icon>
                    {{ $t('message.addEquipment') }}
                    </b-button>
                </b-col>
            </b-row>

            <b-row>
                <b-col v-for="equipment in filteredEquipments" :key="equipment.equpmentId + '_' + (equipment.created_date || '')" cols="12" md="6" class="mb-4 mt-4">
                    <b-card class="equip-card">
                        <div class="equip-card-accent"></div>
                        <b-card-text class="equip-card-body">
                            <div class="equip-card-header" :class="{ 'equip-card-header-rtl': isRTL }">
                                <span class="equip-id-badge">#{{ equipment.equpmentId }}</span>
                                <span class="equip-date">
                                    <b-icon icon="clock" class="equip-clock-icon"></b-icon>
                                    {{ equipment.created_date }}
                                </span>
                            </div>
                            <div class="equip-field">
                                <span class="equip-label">{{ $t('message.equipmentNumber') }}</span>
                                <span class="equip-value equip-id-value">#{{ equipment.equpmentId }}</span>
                            </div>
                            <div class="equip-field">
                                <span class="equip-label">{{ $t('message.equipmentName') }}</span>
                                <span class="equip-value equip-name">{{ equipment.name }}</span>
                            </div>
                            <div class="equip-field">
                                <span class="equip-label">{{ $t('message.serialNumber') }}</span>
                                <span class="equip-value equip-serial">{{ equipment.serial_number }}</span>
                            </div>
                            <div class="equip-field equip-status-row">
                                <span class="equip-label">{{ $t('message.status') }}</span>
                                <span class="equip-status-badge">{{ equipment.equipment_status }}</span>
                            </div>
                        </b-card-text>
                        <template #footer>
                            <button type="button" class="equip-show-details-btn" @click="showDetails(equipment)">
                                <span class="equip-show-details-text">{{ $t('message.showDetails') }}</span>
                                <b-icon :icon="isRTL ? 'chevron-left' : 'chevron-right'" class="equip-show-details-arrow"></b-icon>
                            </button>
                        </template>
                    </b-card>
                </b-col>
                <template v-if="filteredEquipments.length === 0">
                        <div class="text-center p-4" style="width: 100%;">
                            <img :src="require('../assets/not-found.svg')" alt="404 Photo" style="width:100%;">
                            <p class="mb-0 filter-result"> {{ $t('message.noMatchingResults') }} "{{ filter }}".</p>
                        </div>
                </template>
            </b-row>
            <div class="mt-5 pagination">
                    <b-pagination v-model="currentPage" pills :total-rows="rows" :per-page="perPage"></b-pagination>
            </div>
        </div>

        <!-- Modal Add Equipment -->
<b-modal
  id="add-equipment-modal"
  scrollable
  v-model="showAddModal"
  :title="$t('message.addNewEquipment')"
  size="lg"
  dialog-class="add-equipment-modal"
>
  <div class="modal-body p-4">
    <b-row>
      <b-col cols="12">
        <b-form-group :label="$t('message.equipmentImage')">
          <div class="image-upload-area">
            <div v-if="form.img_preview" class="image-preview-container">
              <img :src="form.img_preview" alt="Equipment Preview" class="img-preview" />
              <b-button variant="danger" size="sm" class="remove-image-btn" @click="removeImage">
                <b-icon icon="x-circle"></b-icon>
              </b-button>
            </div>
            <div v-else class="upload-placeholder">
              <b-icon icon="cloud-upload" font-scale="3" class="upload-icon"></b-icon>
              <p class="upload-text">{{ $t('message.clickToUploadImage') }}</p>
              <p class="upload-hint">PNG, JPG, JPEG ({{ $t('message.max') }} 5MB)</p>
            </div>
            <input type="file" ref="imageInput" @change="onImageSelect" accept="image/*" class="file-input" />
          </div>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentFamily')">
          <v-select :dir="direction" v-model="form.equipment_family" :options="equipmentFamilyOptions" label="name"
            :reduce="f => f" :placeholder="$t('message.selectFamily')" @open="fetchEquipmentFamily" class="custom-bg" />
          <div class="mt-2">
            <a href="javascript:void(0)" @click="showAddFamilyModal = true" class="add-family-link">
              <b-icon icon="plus-circle" class="mr-1"></b-icon>
              {{ $t('message.addNewEquipmentFamily') }}
            </a>
          </div>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentType')">
          <v-select :dir="direction" v-model="form.equipment_type" :options="equipmentTypeOptions" label="label"
            :reduce="t => t.value" :placeholder="$t('message.selectEquipmentType')" class="custom-bg" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.mainEquipment')">
          <v-select :dir="direction" v-model="form.main_equipment" :options="mainEquipmentOptions" label="name"
            :reduce="m => m" :placeholder="$t('message.selectMainEquipment')" @open="fetchMainEquipments"
            class="custom-bg" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentName')">
          <b-form-input v-model="form.equipment_name" :placeholder="$t('message.enterEquipmentName')" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentManufactor')">
          <b-form-input v-model="form.equipment_manufactor" :placeholder="$t('message.enterManufacturer')" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.serialNumber')">
          <b-form-input v-model="form.serial_number" :placeholder="$t('message.enterSerial')" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentModel')">
          <b-form-input v-model="form.equipment_model" :placeholder="$t('message.enterModel')" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentCost')">
          <b-form-input v-model="form.cost" type="number" :placeholder="$t('message.enterCost')" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group :label="$t('message.equipmentStatus')">
          <v-select :dir="direction" v-model="form.equipment_status" :options="equipmentStatusOptions"
            :placeholder="$t('message.selectStatus')" class="custom-bg" />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="$t('message.additionalNotes')">
          <b-form-textarea rows="2" v-model="form.additional_note" :placeholder="$t('message.enterNotes')" />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="$t('message.maintenanceSchedule')">
          <b-form-checkbox-group v-model="form.maintenance" class="mt-2 d-flex flex-wrap">
            <b-form-checkbox value="daily" @change="handleMaintenanceChange('daily')">{{ $t('message.daily') }}</b-form-checkbox>
            <b-form-checkbox value="weekly" @change="handleMaintenanceChange('weekly')">{{ $t('message.weekly') }}</b-form-checkbox>
            <b-form-checkbox value="two_week" @change="handleMaintenanceChange('two_week')">{{ $t('message.twoWeek') }}</b-form-checkbox>
            <b-form-checkbox value="monthly" @change="handleMaintenanceChange('monthly')">{{ $t('message.monthly') }}</b-form-checkbox>
            <b-form-checkbox value="two_month" @change="handleMaintenanceChange('two_month')">{{ $t('message.twoMonth') }}</b-form-checkbox>
            <b-form-checkbox value="three_months" @change="handleMaintenanceChange('three_months')">{{ $t('message.threeMonth') }}</b-form-checkbox>
            <b-form-checkbox value="six_months" @change="handleMaintenanceChange('six_months')">{{ $t('message.sixMonth') }}</b-form-checkbox>
            <b-form-checkbox value="yearly" @change="handleMaintenanceChange('yearly')">{{ $t('message.yearly') }}</b-form-checkbox>
            <b-form-checkbox value="not_applicable" @change="handleMaintenanceChange('not_applicable')">{{ $t('message.notApplicable') }}</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="$t('message.orMaintenanceEvery')">
          <div class="d-flex align-items-center">
            <b-form-input v-model="form.units" type="number" class="mr-2" style="width: 100px" />
            <v-select :options="[{ id: 0, name: $t('message.km') }, { id: 1, name: $t('message.hour') }]" label="name"
              v-model="form.unit_type" :placeholder="$t('message.selectUnitType')" :reduce="u => u.id"
              style="width: 150px" />
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="$t('message.dueDate')">
          <b-form-input
            type="datetime-local"
            class="custom-bg"
            v-model="dueDateLocal"
            :min="minDateTime"
            @input="validateDueDate"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </div>

  <template #modal-footer>
    <div class="w-100 text-right">
      <b-button variant="outline-secondary" class="mr-2" @click="showAddModal = false">{{ $t('message.close') }}</b-button>
      <b-button variant="primary" :disabled="!isEquipmentFormValid" @click="submitEquipment">
        <b-icon icon="plus-circle" class="mr-1"></b-icon>{{ $t('message.addEquipment') }}
      </b-button>
    </div>
  </template>
</b-modal>

<!-- Add Equipment Family Modal -->
<b-modal id="add-family-modal" v-model="showAddFamilyModal" :title="$t('message.addNewEquipmentFamily')" size="md">
  <div class="modal-body p-4">
    <b-row>
      <b-col cols="12">
        <b-form-group :label="$t('message.equipmentFamilyName')">
          <b-form-input v-model="familyForm.name" :placeholder="$t('message.equipmentFamilyName')" />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group :label="$t('message.familyCode')">
          <b-form-input v-model="familyForm.family_code" :placeholder="$t('message.familyCode')" />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group :label="$t('message.activityDomain')">
          <b-form-input v-model="familyForm.type_code" :placeholder="$t('message.activityDomain')" />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
  <template #modal-footer>
    <div class="w-100 d-flex justify-content-between">
      <b-button variant="info" @click="navigateToFamiliesList">
        <b-icon icon="list-ul" class="mr-1"></b-icon>{{ $t('message.viewAll') }}
      </b-button>
      <div>
        <b-button variant="outline-secondary" class="mr-2" @click="showAddFamilyModal = false">{{ $t('message.close') }}</b-button>
        <b-button variant="primary" :disabled="!isFamilyFormValid" @click="submitEquipmentFamily">
          <b-icon icon="plus-circle" class="mr-1"></b-icon>{{ $t('message.addFamily') }}
        </b-button>
      </div>
    </div>
  </template>
</b-modal>

    </div>
</template>

<script>
import axiosInstance from '../axios-config';
import { mapGetters } from 'vuex';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    name: 'EquipmentsView',
    components: { VSelect },
    data() {
        return {
            filter: '',
            equipments: [],
            rows: 0,
            currentPage: 1,
            perPage: 10,
            isLoading: true,
            showAddModal: false,
            showAddFamilyModal: false,
            equipmentFamilyOptions: [],
            mainEquipmentOptions: [],
            form: {
                equipment_family: null,
                main_equipment: null,
                serial_number: '',
                cost: '',
                equipment_type: '',
                equipment_model: '',
                equipment_manufactor: '',
                equipment_name: '',
                equipment_status: '',
                additional_note: '',
                maintenance: [],
                units: '',
                unit_type: 0,
                img_url: null,
                img_preview: null,
            },
            familyForm: {
                name: '',
                family_code: '',
                type_code: '',
            },
            dueDate: '',
        };
    },
    computed: {
        ...mapGetters(['getUser']),
        company_id() {
            return this.getUser;
        },
        filteredEquipments() {
            const search = this.filter.toLowerCase();
            const filtered = this.equipments.filter(eq => {
                if (!search) return true;
                const name = (eq.name || '').toLowerCase();
                const serial = (eq.serial_number || '').toLowerCase();
                const status = (eq.equipment_status || '').toLowerCase();
                return name.includes(search) || serial.includes(search) || status.includes(search);
            });
            this.rows = filtered.length;
            const start = (this.currentPage - 1) * this.perPage;
            return filtered.slice(start, start + this.perPage);
        },
        isRTL() {
            return this.$i18n.locale === 'ar';
        },
        direction() {
            return this.$i18n.locale === 'ar' ? 'rtl' : 'ltr';
        },
        equipmentStatusOptions() {
            return [
                this.$t('message.statusNew'),
                this.$t('message.statusUsed')
            ];
        },
        equipmentTypeOptions() {
            const types = [
                { value: 'Fuel tanks', label_ar: 'خزانات وقود', label_en: 'Fuel tanks' },
                { value: 'Metallic pipes', label_ar: 'أنابيب معدنية', label_en: 'Metallic pipes' },
                { value: 'Non metallic pipes', label_ar: 'أنابيب غير معدنية', label_en: 'Non metallic pipes' },
                { value: 'LPG Tank', label_ar: 'خزان غاز البترول المسال (LPG)', label_en: 'LPG Tank' },
                { value: 'Submersible pump', label_ar: 'مضخة غاطسة', label_en: 'Submersible pump' },
                { value: 'Cathodic protection', label_ar: 'حماية كاثودية', label_en: 'Cathodic protection' },
                { value: 'Controlled driver delivery', label_ar: 'توصيل سائق متحكم به', label_en: 'Controlled driver delivery' },
                { value: 'Tank gauging', label_ar: 'قياس الخزانات', label_en: 'Tank gauging' },
                { value: 'Vapour recovery system S1', label_ar: 'نظام استعادة البخار S1', label_en: 'Vapour recovery system S1' },
                { value: 'E-Fuel nozzle', label_ar: 'فوهة وقود إلكترونية', label_en: 'E-Fuel nozzle' },
                { value: 'Fixed fire-fighting systems', label_ar: 'أنظمة إطفاء حريق ثابتة', label_en: 'Fixed fire-fighting systems' },
                { value: 'Fuel dispenser', label_ar: 'موزع وقود', label_en: 'Fuel dispenser' },
                { value: 'Integrated Card reader', label_ar: 'قارئ بطاقات مدمج', label_en: 'Integrated Card reader' },
                { value: 'LPG dispenser', label_ar: 'موزع غاز البترول المسال (LPG)', label_en: 'LPG dispenser' },
                { value: 'Pump controller', label_ar: 'وحدة تحكم بالمضخة', label_en: 'Pump controller' },
                { value: 'Satellite dispenser', label_ar: 'موزع فرعي (ساتلايت)', label_en: 'Satellite dispenser' },
                { value: 'Two-stroke or motorbike dispenser', label_ar: 'موزع وقود لمحركات ثنائية الشوط أو دراجات نارية', label_en: 'Two-stroke or motorbike dispenser' },
                { value: 'Vapour recovery system S2', label_ar: 'نظام استعادة البخار S2', label_en: 'Vapour recovery system S2' },
                { value: 'Air & water unit', label_ar: 'وحدة هواء وماء', label_en: 'Air & water unit' },
                { value: 'Air compressor', label_ar: 'ضاغط هواء', label_en: 'Air compressor' },
                { value: 'Canopies', label_ar: 'مظلات', label_en: 'Canopies' },
                { value: 'Forecourt slab and gutters', label_ar: 'بلاط و مصارف الساحة الأمامية', label_en: 'Forecourt slab and gutters' },
                { value: 'Kiosk', label_ar: 'كشك', label_en: 'Kiosk' },
                { value: 'Oil separator & interceptor', label_ar: 'فاصل ومصيدة الزيت', label_en: 'Oil separator & interceptor' },
                { value: 'Air conditioning', label_ar: 'تكييف هواء', label_en: 'Air conditioning' },
                { value: 'Heating equipment', label_ar: 'معدات تدفئة', label_en: 'Heating equipment' },
                { value: 'Ventilation', label_ar: 'تهوية', label_en: 'Ventilation' },
                { value: 'Solar air conditioning', label_ar: 'تكييف هواء شمسي', label_en: 'Solar air conditioning' },
                { value: 'Cold room and walk-in cooler', label_ar: 'غرفة تبريد ومبرد داخلي', label_en: 'Cold room and walk-in cooler' },
                { value: 'Fridge and refrigeration', label_ar: 'ثلاجة وتبريد', label_en: 'Fridge and refrigeration' },
                { value: 'Shop fittings and furnitures', label_ar: 'تجهيزات ومفروشات المتجر', label_en: 'Shop fittings and furnitures' },
                { value: 'Automatic door', label_ar: 'باب أوتوماتيكي', label_en: 'Automatic door' },
                { value: 'Lift, Hoistaway', label_ar: 'مصعد، رافعة', label_en: 'Lift, Hoistaway' },
                { value: 'Roller shutters', label_ar: 'ستائر دوارة', label_en: 'Roller shutters' },
                { value: 'Fast food and bar equipment', label_ar: 'معدات الوجبات السريعة والبار', label_en: 'Fast food and bar equipment' },
                { value: 'Grease interceptor', label_ar: 'مصيدة الشحوم', label_en: 'Grease interceptor' },
                { value: 'Restaurant fittings and furnitures', label_ar: 'تجهيزات ومفروشات المطعم', label_en: 'Restaurant fittings and furnitures' },
                { value: 'Jet Wash', label_ar: 'غسيل بالضغط العالي', label_en: 'Jet Wash' },
                { value: 'Roll over Car Wash', label_ar: 'غسيل سيارات أوتوماتيكي (رول أوفر)', label_en: 'Roll over Car Wash' },
                { value: 'Vacuum cleaner', label_ar: 'مكنسة كهربائية', label_en: 'Vacuum cleaner' },
                { value: 'Separator & interceptor', label_ar: 'فاصل ومصيدة', label_en: 'Separator & interceptor' },
                { value: 'Water recycling', label_ar: 'إعادة تدوير المياه', label_en: 'Water recycling' },
                { value: 'Used oil tank', label_ar: 'خزان زيت مستعمل', label_en: 'Used oil tank' },
                { value: 'Bay material', label_ar: 'مواد الخليج (منطقة الخدمة)', label_en: 'Bay material' },
                { value: 'Oil change equipment', label_ar: 'معدات تغيير الزيت', label_en: 'Oil change equipment' },
                { value: 'Car lift', label_ar: 'رافعة سيارات', label_en: 'Car lift' },
                { value: 'HV Transformer', label_ar: 'محول جهد عالي (HV)', label_en: 'HV Transformer' },
                { value: 'Lighting equipment', label_ar: 'معدات إضاءة', label_en: 'Lighting equipment' },
                { value: 'UPS', label_ar: 'نظام إمداد الطاقة غير المنقطع (UPS)', label_en: 'UPS' },
                { value: 'Comms cables into DOMS', label_ar: 'كابلات الاتصالات إلى نظام DOMS', label_en: 'Comms cables into DOMS' },
                { value: 'Electrical distribution', label_ar: 'توزيع كهربائي', label_en: 'Electrical distribution' },
                { value: 'Electrical generator set', label_ar: 'مجموعة مولدات كهربائية', label_en: 'Electrical generator set' },
                { value: 'PV Generation', label_ar: 'توليد الطاقة الشمسية الكهروضوئية (PV)', label_en: 'PV Generation' },
                { value: 'Solar equipment', label_ar: 'معدات شمسية', label_en: 'Solar equipment' },
                { value: 'Bullet-proof cabin', label_ar: 'كابينة مضادة للرصاص', label_en: 'Bullet-proof cabin' },
                { value: 'Closed-Circuit TV', label_ar: 'تلفزيون الدائرة المغلقة (CCTV)', label_en: 'Closed-Circuit TV' },
                { value: 'Fire extinguishers', label_ar: 'طفايات حريق', label_en: 'Fire extinguishers' },
                { value: 'Flame detector & alarm system', label_ar: 'كاشف لهب ونظام إنذار', label_en: 'Flame detector & alarm system' },
                { value: 'Lock & Safe', label_ar: 'قفل وخزنة', label_en: 'Lock & Safe' },
                { value: 'Back-office system', label_ar: 'نظام المكتب الخلفي', label_en: 'Back-office system' },
                { value: 'POS (Front-Office)', label_ar: 'نقطة بيع (المكتب الأمامي)', label_en: 'POS (Front-Office)' },
                { value: 'Stand Alone Card Reader', label_ar: 'قارئ بطاقات مستقل', label_en: 'Stand Alone Card Reader' },
                { value: 'HP POS (HARDWARE)', label_ar: 'نقطة بيع HP (أجهزة)', label_en: 'HP POS (HARDWARE)' },
                { value: 'OASIS BOS (SOFTWARE)', label_ar: 'نظام المكتب الخلفي OASIS (برمجيات)', label_en: 'OASIS BOS (SOFTWARE)' },
                { value: 'OASIS POS (SOFTWARE)', label_ar: 'نقطة بيع OASIS (برمجيات)', label_en: 'OASIS POS (SOFTWARE)' },
                { value: 'Audio & Visual', label_ar: 'صوتيات ومرئيات', label_en: 'Audio & Visual' },
                { value: 'Router', label_ar: 'موجه (راوتر)', label_en: 'Router' },
                { value: 'Switch', label_ar: 'محول شبكة (سويتش)', label_en: 'Switch' },
                { value: 'START BOX (VMWARE)', label_ar: 'صندوق START (VMWARE)', label_en: 'START BOX (VMWARE)' },
                { value: 'START CONNECTIVITY', label_ar: 'اتصال START', label_en: 'START CONNECTIVITY' },
                { value: 'Other branding equipment', label_ar: 'معدات علامة تجارية أخرى', label_en: 'Other branding equipment' },
                { value: 'Poster', label_ar: 'ملصق', label_en: 'Poster' },
                { value: 'Totem & Pole Sign', label_ar: 'لافتة عمودية ولوحة إرشادية', label_en: 'Totem & Pole Sign' },
                { value: 'Fresh water treatment', label_ar: 'معالجة المياه العذبة', label_en: 'Fresh water treatment' },
                { value: 'Waste water treatment plant', label_ar: 'محطة معالجة مياه الصرف الصحي', label_en: 'Waste water treatment plant' },
                { value: 'Circulation areas & car parks', label_ar: 'مناطق الحركة ومواقف السيارات', label_en: 'Circulation areas & car parks' },
                { value: 'Gas bottle recipient', label_ar: 'مستقبل أسطوانات الغاز', label_en: 'Gas bottle recipient' },
                { value: 'Road utility vehicles', label_ar: 'مركبات خدمة الطرق', label_en: 'Road utility vehicles' },
                { value: 'Boundary walls-Fences', label_ar: 'جدران حدودية - أسوار', label_en: 'Boundary walls-Fences' },
                { value: 'Green Areas', label_ar: 'مناطق خضراء', label_en: 'Green Areas' },
                { value: 'Portal', label_ar: 'بوابة', label_en: 'Portal' },
                { value: 'Building', label_ar: 'مبنى', label_en: 'Building' },
                { value: 'Roof', label_ar: 'سقف', label_en: 'Roof' },
                { value: 'Other Transversals', label_ar: 'أخرى', label_en: 'Other Transversals' },
            ];
            return types.map(t => ({
                value: t.value,
                label: this.isRTL ? t.label_ar : t.label_en
            }));
        },
        isFamilyFormValid() {
            return this.familyForm.name && this.familyForm.family_code;
        },
        isEquipmentFormValid() {
            const f = this.form;
            return f.serial_number && f.equipment_type && f.equipment_model;
        },
        minDateTime() {
            const now = new Date();
            const y = now.getFullYear();
            const m = String(now.getMonth() + 1).padStart(2, '0');
            const d = String(now.getDate()).padStart(2, '0');
            const h = String(now.getHours()).padStart(2, '0');
            const min = String(now.getMinutes()).padStart(2, '0');
            return `${y}-${m}-${d}T${h}:${min}`;
        },
        dueDateLocal: {
            get() {
                if (!this.dueDate) return '';
                const [datePart, timePart] = this.dueDate.split(' ');
                if (!datePart || !timePart) return '';
                const [hours, minutes] = timePart.split(':');
                return `${datePart}T${hours}:${minutes}`;
            },
            set(value) {
                if (!value) { this.dueDate = ''; return; }
                const [datePart, timePart] = value.split('T');
                if (!datePart || !timePart) return;
                const [hours, minutes] = timePart.split(':');
                const sec = String(new Date().getSeconds()).padStart(2, '0');
                this.dueDate = `${datePart} ${hours}:${minutes}:${sec}`;
            }
        },
    },
    created() {
        this.fetchData();
    },
    methods: {
        formatDateTime(date) {
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            const h = String(date.getHours()).padStart(2, '0');
            const min = String(date.getMinutes()).padStart(2, '0');
            const s = String(date.getSeconds()).padStart(2, '0');
            return `${y}-${m}-${d} ${h}:${min}:${s}`;
        },
        validateDueDate(event) {
            const val = event.target.value;
            if (!val) return;
            if (new Date(val).getTime() < Date.now()) {
                this.dueDate = this.formatDateTime(new Date());
                this.$izitoast.warning({
                    title: this.$t('message.warning'),
                    message: this.$t('message.cannotSelectPastDateTime') || 'Cannot select past date/time',
                    position: 'bottomLeft',
                    timeout: 3000
                });
            }
        },
        openAddEquipmentModal() {
            this.showAddModal = true;
        },
        handleMaintenanceChange(value) {
            this.$nextTick(() => {
                if (value === 'not_applicable' && this.form.maintenance.includes('not_applicable')) {
                    this.form.maintenance = ['not_applicable'];
                } else if (value !== 'not_applicable' && this.form.maintenance.includes('not_applicable')) {
                    this.form.maintenance = this.form.maintenance.filter(x => x !== 'not_applicable');
                }
            });
        },
        async fetchEquipmentFamily() {
            const formData = new FormData();
            formData.append('company_id', this.company_id.company_id);
            const res = await axiosInstance.post('company/select_equipments_family.php', formData);
            if (res.data.status === 'true') this.equipmentFamilyOptions = res.data.output || [];
        },
        async fetchMainEquipments() {
            const formData = new FormData();
            formData.append('company_id', this.company_id.company_id);
            const res = await axiosInstance.post('company/select_equipments.php', formData);
            if (res.data.status === 'true') this.mainEquipmentOptions = res.data.output || [];
        },
        async submitEquipment() {
            try {
                const f = this.form;
                const isNA = f.maintenance.includes('not_applicable');
                const flags = {
                    daily: isNA ? 0 : (f.maintenance.includes('daily') ? 1 : 0),
                    weekly: isNA ? 0 : (f.maintenance.includes('weekly') ? 1 : 0),
                    two_week: isNA ? 0 : (f.maintenance.includes('two_week') ? 1 : 0),
                    monthly: isNA ? 0 : (f.maintenance.includes('monthly') ? 1 : 0),
                    two_month: isNA ? 0 : (f.maintenance.includes('two_month') ? 1 : 0),
                    three_months: isNA ? 0 : (f.maintenance.includes('three_months') ? 1 : 0),
                    six_months: isNA ? 0 : (f.maintenance.includes('six_months') ? 1 : 0),
                    yearly: isNA ? 0 : (f.maintenance.includes('yearly') ? 1 : 0),
                };
                const formData = new FormData();
                formData.append('name', f.equipment_name || '');
                formData.append('serial_number', f.serial_number || '');
                formData.append('equipment_family_id', f.equipment_family?.id || 0);
                formData.append('equipment_type', f.equipment_type || '');
                formData.append('equipment_model', f.equipment_model || '');
                formData.append('equipment_manufactor', f.equipment_manufactor || '');
                formData.append('equipment_id', f.main_equipment?.equpmentId || f.main_equipment?.id || 0);
                formData.append('company_id', this.company_id.company_id);
                formData.append('equipment_status', f.equipment_status || '');
                formData.append('additional_note', f.additional_note || '');
                formData.append('admin_id', this.company_id.id);
                formData.append('description', f.additional_note || '');
                formData.append('siteId', 0);
                formData.append('units', f.units || '');
                formData.append('unit_type', f.unit_type ?? 0);
                formData.append('start_pm_date_mentainance', this.dueDate || '');
                if (f.img_preview) {
                    const base64 = f.img_preview.replace(/^data:image\/\w+;base64,/, '');
                    formData.append('encoded_image', base64);
                }
                Object.entries(flags).forEach(([k, v]) => formData.append(k, v));

                const res = await axiosInstance.post('admin/insert_equipment.php', formData);
                if (res.data.status === 'true') {
                    this.$izitoast.success({ title: 'Success', message: 'Equipment added successfully!', position: 'bottomLeft' });
                    this.showAddModal = false;
                    this.dueDate = '';
                    this.resetForm();
                    this.fetchData();
                } else {
                    this.$izitoast.error({ title: 'Error', message: 'Error adding equipment.', position: 'bottomLeft' });
                }
            } catch (e) {
                console.error(e);
                this.$izitoast.error({ title: 'Error', message: 'Error occurred while sending data.', position: 'bottomLeft' });
            }
        },
        resetForm() {
            this.form = {
                equipment_family: null,
                main_equipment: null,
                serial_number: '',
                cost: '',
                equipment_type: '',
                equipment_model: '',
                equipment_manufactor: '',
                equipment_name: '',
                equipment_status: '',
                additional_note: '',
                maintenance: [],
                units: '',
                unit_type: 0,
                img_url: null,
                img_preview: null,
            };
            this.removeImage();
        },
        async submitEquipmentFamily() {
            try {
                const formData = new FormData();
                formData.append('company_id', this.company_id.company_id);
                formData.append('name', this.familyForm.name);
                formData.append('family_code', this.familyForm.family_code);
                formData.append('type_code', this.familyForm.type_code || '');
                const res = await axiosInstance.post('company/insert_equipment_family.php', formData);
                if (res.data.status === 'true') {
                    this.$izitoast.success({ title: this.$t('message.success'), message: this.$t('message.familyAddedSuccessfully'), position: 'bottomLeft' });
                    this.familyForm = { name: '', family_code: '', type_code: '' };
                    this.showAddFamilyModal = false;
                    this.fetchEquipmentFamily();
                } else {
                    this.$izitoast.error({ title: this.$t('message.error'), message: this.$t('message.errorAddingEquipment'), position: 'bottomLeft' });
                }
            } catch (e) {
                console.error(e);
                this.$izitoast.error({ title: this.$t('message.error'), message: this.$t('message.errorSendingData'), position: 'bottomLeft' });
            }
        },
        navigateToFamiliesList() {
            this.$router.push('/equipment-families');
        },
        onImageSelect(event) {
            const file = event.target.files[0];
            if (!file) return;
            if (file.size > 5 * 1024 * 1024) {
                this.$izitoast.error({ title: this.$t('message.error'), message: this.$t('message.fileTooLarge'), position: 'bottomLeft' });
                return;
            }
            if (!file.type.startsWith('image/')) {
                this.$izitoast.error({ title: this.$t('message.error'), message: this.$t('message.invalidFileType'), position: 'bottomLeft' });
                return;
            }
            this.form.img_url = file;
            const reader = new FileReader();
            reader.onload = e => { this.form.img_preview = e.target.result; };
            reader.readAsDataURL(file);
        },
        removeImage() {
            this.form.img_url = null;
            this.form.img_preview = null;
            if (this.$refs.imageInput) this.$refs.imageInput.value = '';
        },
        async fetchData() {
            try {
                const formData = new FormData();
                formData.append('company_id', this.company_id.company_id);
                const response = await axiosInstance.post('company/select_equipments.php', formData);
                if (response.data.status === 'true' && Array.isArray(response.data.output)) {
                    // Deduplicate by equpmentId - keep first occurrence of each equipment
                    const seen = new Set();
                    this.equipments = response.data.output.filter(item => {
                        const id = item.equpmentId;
                        if (seen.has(id)) return false;
                        seen.add(id);
                        return true;
                    });
                } else {
                    this.equipments = [];
                }
            } catch (error) {
                console.error('Error fetching equipments:', error);
                this.$izitoast.error({
                    title: 'Error',
                    message: 'An error occurred while trying to get equipments',
                    position: 'bottomLeft',
                    timeout: 5000,
                });
                this.equipments = [];
            } finally {
                this.isLoading = false;
            }
        },
        showDetails(equipment) {
            this.$store.commit('setSelectedEquipment', equipment);
            this.$router.push({ name: 'EquipmentProfile' });
        },
    },
};
</script>

<style scoped>
/* ----- Action row: في العربي الزرار على الشمال ----- */
.equip-action-row {
    display: flex;
    flex-wrap: wrap;
}
.equip-filter-col {
    order: 1;
}
.equip-btn-col {
    order: 2;
}
/* RTL: زر إضافة معدة على الشمال */
.equip-page-rtl.equip-action-row .equip-filter-col,
.equip-page-rtl .equip-action-row .equip-filter-col {
    order: 2;
    justify-content: flex-end;
}
.equip-page-rtl.equip-action-row .equip-btn-col,
.equip-page-rtl .equip-action-row .equip-btn-col {
    order: 1;
    text-align: left !important;
}

/* ----- Creative equipment cards ----- */
.equip-card {
    position: relative;
    border: none !important;
    border-radius: 16px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.06) !important;
    overflow: hidden;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.equip-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(60, 137, 206, 0.15), 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}
.equip-card-accent {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #3C89CE 0%, #5BA3E8 50%, #7BBDF5 100%);
    opacity: 0.9;
}
.equip-card-body {
    padding: 20px 18px 12px !important;
}
.equip-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.equip-card-header-rtl {
    flex-direction: row-reverse;
}
.equip-id-badge {
    font-family: 'Somar-Bold';
    font-size: 17px;
    color: #3C89CE;
    background: rgba(60, 137, 206, 0.12);
    padding: 5px 12px;
    border-radius: 8px;
}
.equip-date {
    font-size: 15px;
    color: #6B7280;
    display: inline-flex;
    align-items: center;
    gap: 5px;
}
.equip-clock-icon {
    font-size: 16px;
    color: #9CA3AF;
}
.equip-field {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 12px;
    gap: 12px;
}
.equip-field.equip-status-row {
    margin-bottom: 0;
}
.equip-label {
    font-family: 'Somar-Bold';
    font-size: 15px;
    color: #2B5FA8;
    flex-shrink: 0;
}
.equip-value {
    font-size: 16px;
    color: #374151;
    text-align: end;
    word-break: break-word;
}
.equip-name {
    font-family: 'Somar-Bold';
    font-size: 17px;
    color: #1F2937;
}
.equip-serial {
    font-family: monospace;
    font-size: 15px;
    color: #6B7280;
}
.equip-status-badge {
    font-size: 14px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 20px;
    background: linear-gradient(135deg, rgba(91, 194, 54, 0.2) 0%, rgba(34, 197, 94, 0.15) 100%);
    color: #15803d;
}

/* ----- Show Details: زر واضح وأنيق ----- */
.equip-show-details-btn {
    width: 100%;
    border: none;
    cursor: pointer;
    padding: 16px 20px;
    font-family: 'Somar-Bold';
    font-size: 17px;
    color: #fff;
    background: linear-gradient(135deg, #2B6BB5 0%, #3C89CE 100%);
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.25s ease;
    box-shadow: 0 -2px 10px rgba(44, 107, 181, 0.2);
}
.equip-show-details-btn:hover {
    background: linear-gradient(135deg, #1e5a9e 0%, #2B6BB5 100%);
    box-shadow: 0 -4px 16px rgba(44, 107, 181, 0.35);
}
.equip-show-details-text {
    letter-spacing: 0.02em;
}
.equip-show-details-arrow {
    font-size: 20px;
    transition: transform 0.2s ease;
}
.equip-card:hover .equip-show-details-arrow {
    transform: translateX(4px);
}
.equip-page-rtl .equip-card:hover .equip-show-details-arrow {
    transform: translateX(-4px);
}

.filter-text {
    margin: 0 10px 0 0;
    font-size: 18px;
}
[dir="rtl"] .filter-text {
    margin: 0 0 0 10px;
}
.filter-input {
    max-width: 280px;
    border-radius: 10px;
}

.b-pagination-pills .page-item .page-link {
    line-height: 0.8;
}
.pagination { justify-content: center; display: flex; align-items: center; }

.new-order.equip-add-btn {
    background: linear-gradient(135deg, #FFCA1F 0%, #FFB400 100%);
    border-radius: 14px;
    color: #1F2937;
    min-width: 180px;
    font-size: 17px;
    font-family: 'Somar-Bold';
    border: none;
    box-shadow: 0 4px 14px rgba(255, 193, 7, 0.35);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.new-order.equip-add-btn:hover {
    background: linear-gradient(135deg, #FFD44A 0%, #FFCA1F 100%);
    color: #1F2937;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 193, 7, 0.45);
}

.add-equipment-modal .modal-content {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.15);
    border: none;
}
.add-equipment-modal .modal-header {
    background: linear-gradient(90deg, #ffcc33, #ffb400);
    color: #fff;
    font-family: 'Somar-Bold';
    font-size: 20px;
    border-bottom: none;
    padding: 16px 20px;
}
.add-equipment-modal .form-group label {
    font-weight: 600;
    color: #333;
    margin-bottom: 6px;
    font-size: 15px;
}
.add-equipment-modal .b-form-checkbox-group { display: flex; flex-wrap: wrap; gap: 10px 20px; }
.add-equipment-modal .b-form-checkbox {
    background-color: #fff;
    padding: 5px 10px;
    border-radius: 8px;
    border: 1px solid #ddd;
}
.add-equipment-modal .modal-footer {
    background-color: #fff;
    padding: 15px 20px;
    border-top: 1px solid #eee;
    justify-content: flex-end;
}
.add-equipment-modal .modal-footer .btn { border-radius: 10px; padding: 8px 20px; font-size: 15px; font-weight: 600; }
.add-equipment-modal .btn-primary { background: linear-gradient(90deg, #ffb400, #ffca1f); border: none; }
.add-equipment-modal .btn-primary:hover { background: linear-gradient(90deg, #ffca1f, #ffb400); }
.add-equipment-modal .btn-outline-secondary { border-color: #ccc; color: #555; }
.add-family-link {
    color: #2274BD;
    font-family: 'Somar-Bold';
    font-size: 14px;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    transition: all 0.3s ease;
}
.add-family-link:hover { color: #FFD448; text-decoration: underline; }
.image-upload-area {
    position: relative;
    border: 2px dashed #d1d5db;
    border-radius: 12px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #f9fafb;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image-upload-area:hover { border-color: #FFB400; background: #fffbf0; }
.file-input { position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer; }
.upload-placeholder { display: flex; flex-direction: column; align-items: center; justify-content: center; }
.upload-icon { color: #9ca3af; margin-bottom: 12px; }
.upload-text { font-weight: 600; color: #374151; margin-bottom: 4px; font-size: 16px; }
.upload-hint { color: #9ca3af; font-size: 14px; margin-bottom: 0; }
.image-preview-container { position: relative; width: 100%; max-width: 300px; margin: 0 auto; }
.img-preview { width: 100%; height: auto; max-height: 200px; object-fit: contain; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
.remove-image-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
@media (max-width: 768px) {
    .new-order { width: 100%; font-size: 18px; margin: 10px 0; }
}
@media (max-width: 576px) {
    .filter-text { font-size: 20px !important; }
    .filter-input { width: 120px !important; }
}
</style>
